<template>
    <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden" class="tabbed">
        <template slot="modal-header">
            <h1>{{ Translations.sections.clocks.edition.title }}</h1>

            <ul class="nav">
                <li :active="modalState.activeTab=='basic'">
                    <a @click.prevent="modalState.activeTab='basic'">{{Translations.sections.clocks.edition.tabs.basic.title}}</a>
                </li>
<!--                <li :active="modalState.activeTab=='constraints'">-->
<!--                    <a @click.prevent="modalState.activeTab='constraints'">{{Translations.sections.clocks.edition.tabs.constraints.title}}</a>-->
<!--                </li>-->
            </ul>
        </template>
        <template>
            <WaitingBlock v-if="modalState.isLoadingClock">
            </WaitingBlock>
            <b-form class="form" v-else>
                <div :class="['tab',{'active' : modalState.activeTab=='basic'}]">
                    <input type="hidden" id="stationUid" name="stationUid" v-model="clockData.stationUid" />
                    <div class="linked-properties">
                        <b-form-group id="group-name" :label="Translations.labels.name" label-for="name" :label-cols="4">
                            <b-form-input id="name" name="name" v-model="clockData.name" type="text" required autocomplete="off" :placeholder="Translations.placeholders.name" />
                        </b-form-group>
                        <b-form-group id="color-container" :label="Translations.labels.color" label-for="colorCode" :label-cols="4">
                            <b-form-input id="name" name="colorCode" v-model="clockData.colorCode" type="color" :placeholder="Translations.placeholders.color" />
                        </b-form-group>
                    </div>
                </div>
                <div :class="['tab', {'active' : modalState.activeTab=='constraints'}]">
                    <div class="alert alert-warning">Coming Soon</div>
                    <!--<Button :empty="true" noBorder="true" disabled><i class="fas fa-plus"></i>&nbsp;Add Constraint</Button>-->
                </div>
            </b-form>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }} </Button>
            <Button :empty="false" class="validate" v-if="!modalState.isLoadingClock" @click.prevent="editClock">{{ Translations.buttons.doEditClock }} </Button>
        </template>
    </b-modal>
</template>

<script>
    import Button from'@/components/common/Button';
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import router from '@/router';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue';
    import { HTTP } from "@/utils/http";
    import { mapState } from 'vuex';
    import WaitingBlock from'@/components/common/WaitingBlock'

    export default {
        name: "ClockEditionCard",
        store,
        components: { Portlet, Bootstrap, Button, WaitingBlock },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            errorMessages: function (inputName) {
                if (this.editionResponse == null || this.editionResponse.errors == null) return [];
            },
        },
        props: {
            clockUid: { type: String, required: true }
        },
        mounted() {
            this.loadClock();
        },
        watch: {
            currentStation: function () { console.log('station loaded'); }
        },
        data() {
            return {
                modalState: {
                    show: true,
                    visible: true,
                    activeTab: 'basic',
                    isLoadingClock: true,
                },
                clockData: null,
                editionResponse: null
            }
        }
        , methods: {
            loadClock() {
                try {
                    if (this.currentStation != null && this.clockUid != null) {
                        console.log("Loading clock for edition")
                        this.modalState.isLoadingClock = true;
                        HTTP
                            .get('api/clocks/details', {
                                params: { stationUid: this.currentStation.uid, clockUid: this.clockUid }
                            })
                            .then(this.onClockLoaded, this.onClockLoadError)
                            .then(this.onClockLoadComplete);
                    }
                    else {
                    }
                } catch (e) {
                    console.log("loadClock -> error:", e);
                }
            },
            onClockLoaded(response) { this.clockData = response.data.dataItem; },
            onClockLoadError(response) { this.clockData = null; },
            onClockLoadComplete(response) { this.modalState.isLoadingClock = false; },

            editClock() {
                HTTP.post("api/clocks/edit", this.clockData)
                    .then(this.onClockEdited, this.onClockCreationError)
                    .then(function () {
                        console.log("End...")
                    });
            },
            onClockEdited(response) {
                this.editionResponse = response;
                if (this.editionResponse.status === 200) {
                    var editedClockResponse = this.editionResponse.data;
                    if (editedClockResponse != null && editedClockResponse.dataItem != null) {
                        //router.push({ name: 'BoxDetails', params: { uid: newBox.dataItem.uid } });
                        store.dispatch('loadStationClocks', this.currentStation.uid);
                        store.commit('setCurrentClock', this.editionResponse.data.dataItem);
                        this.cancelModal();
                    }
                }
                else {
                    //let vue build the error messages
                }
                //this.cancelModal();
            },
            onClockEditionError(response) {
                console.log(response);
                this.editionResponse = response;
                console.error(response);
            },
            cancelModal() { this.$refs['modal'].hide() },
            onModalHidden() { EventBus.$emit('onClockEditionEnded'); }
        }
    }
</script>

<style>
</style>